export const extractLocationFromSettings = (
  settings:
    | {
        country_iso_code?: string;
        zip_code?: string;
      }
    | null
    | undefined,
) => {
  if (!settings?.country_iso_code && !settings?.zip_code) return null;
  return {
    country: settings.country_iso_code,
    postal_code: settings.zip_code,
  };
};

export const formatName = (firstName: string, teamName?: string) => {
  return teamName ? teamName : `${firstName}'s Workspace`;
};
